<template>
  <Form :ref="'form' + current" :model="form" :rules="rules" :label-width="165">
    <Divider orientation="left">申请人基本信息</Divider>

    <Row :gutter="16">
      <!-- <Col span="24">
      <FormItem label="业务类别" prop="ywlb">
        <Select v-model.trim="form.ywlb" placeholder="积分新办：年龄+教育背景（高于或等于本科学士）+社保年限" style="width:100%">
          <Option v-for="select in ywlbList" :value="select.value" :key="select.value">{{ select.name }}</Option>
        </Select>
      </FormItem>
      </Col> -->

      <Col span="12">
      <FormItem label="上传申请人身份证人像面" prop="applicantIDCardFrontGuid">
        <Row :gutter="16">
          <Col span="24">
          <div class="line_area">
            <div>
              <Upload type="drag" class="uploadImage" :max-size="5120" :on-exceeded-size="handleMaxSize" :on-progress="( event, file, fileList)=>updateProgress( event, file, fileList,'applicantIDCardFrontGuidProgress')"
                :show-upload-list="false" :accept="accept" :format="format" :data="{readIdInfo: true,applicationGuid:form.guid,checkRepeatApplication:true,applicationType:form.applicationType,}" :on-success="
                    (response, file, fileList) =>
                     {$refs['applicantIDCardFrontGuidProgress'].updateShow(false)
        $refs['applicantIDCardFrontGuidProgressUpload'].style.display = 'block'; handleSuccess(
                        response,
                        file,
                        fileList,
                        'applicantIDCardFrontGuid',false,'idCard',[{name:'applicantName'},{idCard:'applicantIDCardNo'}]
                      )}
                  " :on-format-error="handleFormatError" :action="$baseURL + '/common/file/uploadfile'">
                <div class="uploadBg">
                  <span ref="applicantIDCardFrontGuidProgressUpload">
                    <Icon @click.stop="()=>{return false}" type="ios-add" size="80" style="color: rgba(192, 192, 192,0.5)"></Icon>
                    <div class="upload_btn">
                      <Icon type="ios-folder" />&nbsp;&nbsp;上传电脑图片
                    </div>
                    <div class="upload_btn" @click.stop="openQrCodeUpload('applicantIDCardFrontGuid',false,'idCard',[{name:'applicantName'},{idCard:'applicantIDCardNo'}])">
                      <Icon type="ios-camera" />&nbsp;&nbsp;手机拍照上传
                    </div>
                  </span>
                  <progress-bar ref="applicantIDCardFrontGuidProgress"></progress-bar>
                </div>
              </Upload>

            </div>
            <!-- 已上传图片 -->
            <div class="fileList" v-if="form.applicantIDCardFrontGuid">
              <span class="pos">
                <img class="img uploadImage" :src="
                        $baseURL +
                        '/file/cover/' +
                        form.applicantIDCardFrontGuid
                      " />
                <i class="img_magnify">
                  <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.applicantIDCardFrontGuid)" type="ios-eye" />
                  <Icon size="26" class="ico" color="#ffffff" @click="
                          handleRemove(
                            0,
                            form.applicantIDCardFrontGuid,
                            'applicantIDCardFrontGuid'
                          )
                        " type="ios-trash-outline" />
                </i>
              </span>
            </div>
            <div class="fileList" v-else>
              <span class="pos">
                <span class="img">
                  <span class="uploadImageNo">
                    <Icon type="ios-image" size="30" />
                  </span>
                </span>
              </span>
            </div>
          </div>
          </Col>
        </Row>
      </FormItem>
      </Col>
      <Col span="12">
      <FormItem label="上传申请人身份证国徽面" prop="applicantIDCardBackGuid">
        <Row :gutter="16">
          <Col span="24">
          <div class="line_area">
            <Upload multiple type="drag" ref="applicantIDCardBackGuid" :data="{readIdbackAfterUploaded: true}" :on-progress="( event, file, fileList)=>updateProgress( event, file, fileList,'applicantIDCardBackGuidProgress')"
              class="uploadImage" :accept="accept" :format="format" :show-upload-list="false" :on-success="
                    (response, file, fileList) =>
                     {$refs['applicantIDCardBackGuidProgress'].updateShow(false)
        $refs['applicantIDCardBackGuidProgressUpload'].style.display = 'block'; handleSuccess(
                        response,
                        file,
                        fileList,
                        'applicantIDCardBackGuid',false,'idcard_back'
                      )}
                  " :on-format-error="handleFormatError" :action="$baseURL + '/common/file/uploadfile'">
              <div class="uploadBg">
                <span ref="applicantIDCardBackGuidProgressUpload">
                  <Icon @click.stop="()=>{return false}" type="ios-add" size="80" style="color: rgba(192, 192, 192,0.5)"></Icon>
                  <div class="upload_btn">
                    <Icon type="ios-folder" />&nbsp;&nbsp;上传电脑图片
                  </div>
                  <div class="upload_btn" @click.stop="openQrCodeUpload('applicantIDCardBackGuid',false,'idcard_back')">
                    <Icon type="ios-camera" />&nbsp;&nbsp;手机拍照上传
                  </div>
                </span>
                <progress-bar ref="applicantIDCardBackGuidProgress"></progress-bar>
              </div>
            </Upload>
            <!-- 已上传图片 -->
            <div class="fileList" v-if="form.applicantIDCardBackGuid">
              <span class="pos">
                <img class="img uploadImage" :src="
                        $baseURL + '/file/cover/' + form.applicantIDCardBackGuid
                      " />
                <i class="img_magnify">
                  <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.applicantIDCardBackGuid)" type="ios-eye" />
                  <Icon size="26" class="ico" color="#ffffff" @click="
                          handleRemove(
                            0,
                            form.applicantIDCardBackGuid,
                            'applicantIDCardBackGuid'
                          )
                        " type="ios-trash-outline" />
                </i>
              </span>
            </div>
            <div class="fileList" v-else>
              <span class="pos">
                <span class="img">
                  <span class="uploadImageNo">
                    <Icon type="ios-image" size="30" />
                  </span>
                </span>
              </span>
            </div>
          </div>
          </Col>
        </Row>
      </FormItem>
      </Col>
      <Col span="12">
      <FormItem label="申请人姓名" prop="applicantName">
        <Input v-model.trim="form.applicantName" disabled :maxlength="20" placeholder="上传身份证人像面自动识别"></Input>
      </FormItem>
      </Col>
      <Col span="12">
      <FormItem label="申请人身份证号" prop="applicantIDCardNo">
        <Input v-model.trim="form.applicantIDCardNo" disabled :maxlength="20" placeholder="上传身份证人像面自动识别"></Input>
      </FormItem>
      </Col>
      <Col span="24">
      <FormItem label="申请人联系方式" prop="applicantPhone">
        <Input v-model.trim="form.applicantPhone" :maxlength="40" placeholder="请填写"></Input>
      </FormItem>
      </Col>
      <Col span="24">
      <FormItem label="户籍类型" prop="applicantRegisteredResidenceType">
        <RadioGroup v-model.trim="form.applicantRegisteredResidenceType">
          <Radio :label="value" v-for="{text,value} in $store.state.materiaBasicData.registeredResidenceType" :key="value">{{text}}</Radio>
        </RadioGroup>
      </FormItem>
      </Col>
      <Col span="24" v-if="form.applicantRegisteredResidenceType===$store.state.registeredResidenceType['集体户口']">
      <FormItem label="集体户口类型" prop="applicantCollectiveAccountMaterialsType">
        <RadioGroup v-model.trim="form.applicantCollectiveAccountMaterialsType">
          <Radio :label="value" v-for="{text,value} in $store.state.materiaBasicData.collectiveAccountMaterialsTypes" :key="value">{{text}}</Radio>
        </RadioGroup>
      </FormItem>
      </Col>
      <template
        v-if="form.applicantRegisteredResidenceType===$store.state.registeredResidenceType['家庭户口']||(form.applicantRegisteredResidenceType===$store.state.registeredResidenceType['集体户口']&&form.applicantCollectiveAccountMaterialsType===$store.state.collectiveAccountMaterialsTypes['户口簿'])">
        <Col span="12">
        <FormItem label="上传户口簿详细地址页的首页" prop="applicantResidenceBookletMainPageGuid">
          <Row :gutter="16">
            <Col span="24">
            <div class="line_area">
              <Upload multiple type="drag" class="uploadImage" :on-progress="( event, file, fileList)=>updateProgress( event, file, fileList,'applicantResidenceBookletMainPageGuidProgress')" :accept="accept" :format='format'
                :show-upload-list='false' :on-success="(response, file, fileList)=>{$refs['applicantResidenceBookletMainPageGuidProgress'].updateShow(false)
        $refs['applicantResidenceBookletMainPageGuidProgressUpload'].style.display = 'block';handleSuccess(response, file, fileList,'applicantResidenceBookletMainPageGuid')}" :on-format-error="handleFormatError"
                :action="$baseURL+'/common/file/uploadfile'">
                <div class="uploadBg">
                  <span ref="applicantResidenceBookletMainPageGuidProgressUpload">
                    <Icon @click.stop="()=>{return false}" type="ios-add" size="80" style="color: rgba(192, 192, 192,0.5)"></Icon>
                    <div class="upload_btn">
                      <Icon type="ios-folder" />&nbsp;&nbsp;上传电脑图片
                    </div>
                    <div class="upload_btn" @click.stop="openQrCodeUpload('applicantResidenceBookletMainPageGuid')">
                      <Icon type="ios-camera" />&nbsp;&nbsp;手机拍照上传
                    </div>
                  </span>
                  <progress-bar ref="applicantResidenceBookletMainPageGuidProgress"></progress-bar>

                </div>
              </Upload>
              <!-- 已上传图片 -->
              <div class="fileList" v-if="form.applicantResidenceBookletMainPageGuid">
                <!-- <template v-for="(img, img_i) in form.personnelIDCardBackGuid"> -->
                <span class="pos">
                  <img class="img uploadImage" :src="$baseURL+'/file/cover/'+ form.applicantResidenceBookletMainPageGuid" />
                  <i class="img_magnify">
                    <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.applicantResidenceBookletMainPageGuid)" type="ios-eye" />

                    <Icon size="26" class="ico" color="#ffffff" @click="handleRemove(0,form.applicantResidenceBookletMainPageGuid,'applicantResidenceBookletMainPageGuid')" type="ios-trash-outline" />
                  </i>
                </span>
                <!-- </template> -->
              </div>
              <div class="fileList" v-else>
                <span class="pos">
                  <span class="img">
                    <span class="uploadImageNo">
                      <Icon type="ios-image" size="30" />
                    </span>
                  </span>
                </span>
              </div>
            </div>
            </Col>
          </Row>
        </FormItem>
        </Col>
        <Col span="12">
        <FormItem label="上传户口簿本人信息页" prop="applicantResidenceBookletSelfPageGuid">
          <Row :gutter="16">
            <Col span="24">
            <div class="line_area">
              <Upload multiple type="drag" class="uploadImage" :on-progress="( event, file, fileList)=>updateProgress( event, file, fileList,'applicantResidenceBookletSelfPageGuidProgress')" :accept="accept" :format='format'
                :show-upload-list='false' :on-success="(response, file, fileList)=>{$refs['applicantResidenceBookletSelfPageGuidProgress'].updateShow(false)
        $refs['applicantResidenceBookletSelfPageGuidProgressUpload'].style.display = 'block';handleSuccess(response, file, fileList,'applicantResidenceBookletSelfPageGuid')}" :on-format-error="handleFormatError"
                :action="$baseURL+'/common/file/uploadfile'">
                <div class="uploadBg">
                  <span ref="applicantResidenceBookletSelfPageGuidProgressUpload">
                    <Icon @click.stop="()=>{return false}" type="ios-add" size="80" style="color: rgba(192, 192, 192,0.5)"></Icon>
                    <div class="upload_btn">
                      <Icon type="ios-folder" />&nbsp;&nbsp;上传电脑图片
                    </div>
                    <div class="upload_btn" @click.stop="openQrCodeUpload('applicantResidenceBookletSelfPageGuid')">
                      <Icon type="ios-camera" />&nbsp;&nbsp;手机拍照上传
                    </div>
                  </span>
                  <progress-bar ref="applicantResidenceBookletSelfPageGuidProgress"></progress-bar>

                </div>
              </Upload>
              <div class="fileList" v-if="form.applicantResidenceBookletSelfPageGuid">
                <span class="pos">
                  <img class="img uploadImage" :src="$baseURL+'/file/cover/'+ form.applicantResidenceBookletSelfPageGuid" />
                  <i class="img_magnify">
                    <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.applicantResidenceBookletSelfPageGuid)" type="ios-eye" />
                    <Icon size="26" class="ico" color="#ffffff" @click="handleRemove(0,form.applicantResidenceBookletSelfPageGuid,'applicantResidenceBookletSelfPageGuid')" type="ios-trash-outline" />
                  </i>
                </span>
              </div>
              <div class="fileList" v-else>
                <span class="pos">
                  <span class="img">
                    <span class="uploadImageNo">
                      <Icon type="ios-image" size="30" />
                    </span>
                  </span>
                </span>
              </div>
            </div>
            </Col>
          </Row>
        </FormItem>
        </Col>
      </template>
      <template v-if="form.applicantRegisteredResidenceType===$store.state.registeredResidenceType['集体户口']&&form.applicantCollectiveAccountMaterialsType===$store.state.collectiveAccountMaterialsTypes['派出所出具的户籍证明']">
        <Col span="12">
        <FormItem label="派出所出具的户籍证明" prop="applicantPoliceStationRegistrationCertificateGuid">
          <Row :gutter="16">
            <Col span="24">
            <div class="line_area">
              <Upload multiple type="drag" class="uploadImage" :on-progress="( event, file, fileList)=>updateProgress( event, file, fileList,'applicantPoliceStationRegistrationCertificateGuidProgress')" :accept="accept" :format='format'
                :show-upload-list='false' :on-success="(response, file, fileList)=>{$refs['applicantPoliceStationRegistrationCertificateGuidProgress'].updateShow(false)
        $refs['applicantPoliceStationRegistrationCertificateGuidProgressUpload'].style.display = 'block';handleSuccess(response, file, fileList,'applicantPoliceStationRegistrationCertificateGuid')}" :on-format-error="handleFormatError"
                :action="$baseURL+'/common/file/uploadfile'">
                <div class="uploadBg">
                  <span ref="applicantPoliceStationRegistrationCertificateGuidProgressUpload">
                    <Icon @click.stop="()=>{return false}" type="ios-add" size="80" style="color: rgba(192, 192, 192,0.5)"></Icon>
                    <div class="upload_btn">
                      <Icon type="ios-folder" />&nbsp;&nbsp;上传电脑图片
                    </div>
                    <div class="upload_btn" @click.stop="openQrCodeUpload('applicantPoliceStationRegistrationCertificateGuid')">
                      <Icon type="ios-camera" />&nbsp;&nbsp;手机拍照上传
                    </div>
                  </span>
                  <progress-bar ref="applicantPoliceStationRegistrationCertificateGuidProgress"></progress-bar>

                </div>
              </Upload>
              <!-- 已上传图片 -->
              <div class="fileList" v-if="form.applicantPoliceStationRegistrationCertificateGuid">
                <!-- <template v-for="(img, img_i) in form.personnelIDCardBackGuid"> -->
                <span class="pos">
                  <img class="img uploadImage" :src="$baseURL+'/file/cover/'+ form.applicantPoliceStationRegistrationCertificateGuid" />
                  <i class="img_magnify">
                    <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.applicantPoliceStationRegistrationCertificateGuid)" type="ios-eye" />

                    <Icon size="26" class="ico" color="#ffffff" @click="handleRemove(0,form.applicantPoliceStationRegistrationCertificateGuid,'applicantPoliceStationRegistrationCertificateGuid')" type="ios-trash-outline" />
                  </i>
                </span>
                <!-- </template> -->
              </div>
              <div class="fileList" v-else>
                <span class="pos">
                  <span class="img">
                    <span class="uploadImageNo">
                      <Icon type="ios-image" size="30" />
                    </span>
                  </span>
                </span>
              </div>
            </div>
            </Col>
          </Row>
        </FormItem>
        </Col>
      </template>

      <Col span="24">
      <FormItem label="上传申请人居住证正面" prop="applicantResidencePermitFrontGuid">
        <Row :gutter="16">
          <Col span="24">
          <div class="line_area">
            <Upload multiple type="drag" class="uploadImage" :max-size="5120" :on-exceeded-size="handleMaxSize" :accept="accept" :format="format" :data="{readResidencePermit:true,}"
              :on-progress="( event, file, fileList)=>updateProgress( event, file, fileList,'applicantResidencePermitFrontGuidProgress')" :show-upload-list="false" :on-success="
                    (response, file, fileList) =>
                    {  $refs['applicantResidencePermitFrontGuidProgress'].updateShow(false)
        $refs['applicantResidencePermitFrontGuidProgressUpload'].style.display = 'block';handleSuccess(
                        response,
                        file,
                        fileList,
                        'applicantResidencePermitFrontGuid',false,'residencePermit',[{residencePermitExpiryDate:'applicantResidencePermitExpiryDate'}]
                      )}
                  " :on-format-error="handleFormatError" :action="$baseURL + '/common/file/uploadfile'">
              <div class="uploadBg">
                <span ref="applicantResidencePermitFrontGuidProgressUpload">
                  <Icon @click.stop="()=>{return false}" type="ios-add" size="80" style="color: rgba(192, 192, 192,0.5)"></Icon>
                  <div class="upload_btn">
                    <Icon type="ios-folder" />&nbsp;&nbsp;上传电脑图片
                  </div>
                  <div class="upload_btn" @click.stop="openQrCodeUpload('applicantResidencePermitFrontGuid',false,'residencePermit',[{residencePermitExpiryDate:'applicantResidencePermitExpiryDate'}])">
                    <Icon type="ios-camera" />&nbsp;&nbsp;手机拍照上传
                  </div>
                </span>
                <progress-bar ref="applicantResidencePermitFrontGuidProgress"></progress-bar>
              </div>
            </Upload>
            <!-- 已上传图片 -->
            <div class="fileList" v-if="form.applicantResidencePermitFrontGuid">
              <span class="pos">
                <img class="img uploadImage" :src="
                        $baseURL +
                        '/file/cover/' +
                        form.applicantResidencePermitFrontGuid
                      " />
                <i class="img_magnify">
                  <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.applicantResidencePermitFrontGuid)" type="ios-eye" />
                  <Icon size="26" class="ico" color="#ffffff" @click="
                          handleRemove(
                            0,
                            form.applicantResidencePermitFrontGuid,
                            'applicantResidencePermitFrontGuid'
                          )
                        " type="ios-trash-outline" />
                </i>
              </span>
            </div>
            <div class="fileList" v-else>
              <span class="pos">
                <span class="img">
                  <span class="uploadImageNo">
                    <Icon type="ios-image" size="30" />
                  </span>
                </span>
              </span>
            </div>
          </div>
          </Col>
        </Row>
      </FormItem>
      </Col>
      <!-- <Col span="12">
        <FormItem label="上传申请人居住证反面" prop="applicantResidencePermitBackGuid">
          <Row :gutter="16">
            <Col span="24">
            <div class="line_area">
              <Upload multiple type="drag" class="uploadImage" :accept="accept" :on-progress="( event, file, fileList)=>updateProgress( event, file, fileList,'applicantResidencePermitBackGuidProgress')" :format="format"
                :show-upload-list="false" :on-success="
                    (response, file, fileList) =>
                      {$refs['applicantResidencePermitBackGuidProgress'].updateShow(false)
        $refs['applicantResidencePermitBackGuidProgressUpload'].style.display = 'block';handleSuccess(
                        response,
                        file,
                        fileList,
                        'applicantResidencePermitBackGuid'
                      )}
                  " :on-format-error="handleFormatError" :action="$baseURL + '/common/file/uploadfile'">
                <div class="uploadBg">
                  <span ref="applicantResidencePermitBackGuidProgressUpload">
                    <Icon @click.stop="()=>{return false}" type="ios-add" size="80" style="color: rgba(192, 192, 192,0.5)"></Icon>
                    <div class="upload_btn">
                      <Icon type="ios-folder" />&nbsp;&nbsp;上传电脑图片
                    </div>
                    <div class="upload_btn" @click.stop="openQrCodeUpload('applicantResidencePermitBackGuid')">
                      <Icon type="ios-camera" />&nbsp;&nbsp;手机拍照上传
                    </div>
                  </span>
                  <progress-bar ref="applicantResidencePermitBackGuidProgress"></progress-bar>
                </div>
              </Upload>
              <div class="fileList" v-if="form.applicantResidencePermitBackGuid">
                <span class="pos">
                  <img class="img uploadImage" :src="
                        $baseURL +
                        '/file/cover/' +
                        form.applicantResidencePermitBackGuid
                      " />
                  <i class="img_magnify">
                    <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.applicantResidencePermitBackGuid)" type="ios-eye" />
                    <Icon size="26" class="ico" color="#ffffff" @click="
                          handleRemove(
                            0,
                            form.applicantResidencePermitBackGuid,
                            'applicantResidencePermitBackGuid'
                          )
                        " type="ios-trash-outline" />
                  </i>
                </span>
              </div>
              <div class="fileList" v-else>
                <span class="pos">
                  <span class="img">
                    <span class="uploadImageNo">
                      <Icon type="ios-image" size="30" />
                    </span>
                  </span>
                </span>
              </div>
            </div>
            </Col>
          </Row>
        </FormItem>
        </Col> -->
      <Col span="12">
      <FormItem label="居住证截止时间" prop="applicantResidencePermitExpiryDate">
        <DatePicker type="date" :editable="false" v-model.trim="form.applicantResidencePermitExpiryDate" placeholder="请选择" style="width: 100%" />
      </FormItem>
      </Col>
      <Col span="24">
      <FormItem class="noticeTop" label="申报事项" prop="declarationItems">
        <Input v-model.trim="form.declarationItems" :maxlength="200" show-word-limit type="textarea" placeholder="请简述申报事项内容" style="width: 100%" />
      </FormItem>
      <FormItem class="notice">
        <div>
          温馨提示：请先至上海市居住证积分办理系统（https://www.rsj.sh.gov.cn/jzzjf/）进行填报并完成申报后在至本系统进行材料上传。
        </div>
      </FormItem>
      </Col>
      <Col span="24">
      <FormItem class="noticeTop" label="是否有人事档案" prop="hasPersonFiles">
        <RadioGroup v-model.trim="form.hasPersonFiles">
          <Radio :label="true">是</Radio>
          <Radio :label="false">否</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem class="notice">
        <div>
          注：若申请人才为高中及以上学历，无人事档案应至户籍地人才中心建档
        </div>
      </FormItem>
      </Col>
      <Col span="24">
      <FormItem v-show="form.hasPersonFiles===true&&$store.state.isPassFilesManagementAptitude" :rules="{ required: form.hasPersonFiles===true&&$store.state.isPassFilesManagementAptitude, message: '请输入', trigger: 'change',type:'boolean' }"
        label="档案是否在本单位" prop="hasPersonFiles">
        <RadioGroup v-model.trim="form.isArchiveInCurrentEnterprise" @on-change="isArchiveInCurrentEnterpriseChange">
          <Radio :label="true">是</Radio>
          <Radio :label="false">否</Radio>
        </RadioGroup>
      </FormItem>
      </Col>
      <Col span="24">
      <FormItem v-show="form.hasPersonFiles===true" label="人事档案保管机构" prop="applicantArchivesCustodyInstitution" :rules="{ required: form.hasPersonFiles===true, message: '请输入', trigger: 'change' }">
        <Input :disabled="form.isArchiveInCurrentEnterprise" v-model.trim="form.applicantArchivesCustodyInstitution" :maxlength="50" placeholder="请填写">
        </Input>
      </FormItem>
      </Col>
      <Col span="24">
      <FormItem v-show="form.hasPersonFiles===false" label="无档案证明" prop="noPersonFileProofGuidList" :rules="{ required: form.hasPersonFiles===false, message: '请上传',type: 'array', trigger: 'change' }">
        <div>
          <Upload :show-upload-list="false" :accept="$store.state.globalAccept" :format="$store.state.globalFormat" :default-file-list="form.noPersonFileProofGuidListPreview" :on-preview="handlePreview"
            :action="$baseURL + '/common/file/uploadfile'" :on-remove="
              (file, fileList) =>
                handleRemove(file, fileList, 'noPersonFileProofGuidList',true)
            " :on-success="
              (response, file, fileList) =>
                handleSuccess(response, file, fileList, 'noPersonFileProofGuidList',true)
            " :on-format-error="handleFormatError">
            <Button icon="ios-folder">上传电脑文件</Button>&nbsp;
            <Button icon="ios-camera" @click.stop="openQrCodeUpload('noPersonFileProofGuidList',true)">手机拍照上传</Button>
          </Upload>
          <div class="_linkdel" v-for="file in form.noPersonFileProofGuidListPreview" :key="file.guid">
            <div class="fileCentent" @click="handlePreview(file)">
              <Icon :type="file.name | fileType" />
              {{file.name?file.name:file.fileName}}
            </div>
            <div class="fileDel">
              <Icon type="md-close" @click="handleRemove(file, null, 'noPersonFileProofGuidList',true)" />
            </div>
          </div>
        </div>
      </FormItem>
      </Col>
      <Divider orientation="left">申请人劳务合同上传</Divider>
      <Col span="12">
      <FormItem label="近6个月个人所得税完税证明" prop="applicantTaxPaymentCertificateGuidList">
        <Upload :show-upload-list="false" :accept="$store.state.globalAccept" :format="$store.state.globalFormat" :default-file-list="form.applicantTaxPaymentCertificateGuidListPreview" :on-preview="handlePreview"
          :action="$baseURL + '/common/file/uploadfile'" :on-remove="
              (file, fileList) =>
                handleRemove(file, fileList, 'applicantTaxPaymentCertificateGuidList',true)
            " :on-success="
              (response, file, fileList) =>
                handleSuccess(response, file, fileList, 'applicantTaxPaymentCertificateGuidList',true)
            " :on-format-error="handleFormatError">
          <Button icon="ios-folder">上传电脑文件</Button>&nbsp;
          <Button icon="ios-camera" @click.stop="openQrCodeUpload('applicantTaxPaymentCertificateGuidList',true)">手机拍照上传</Button>
        </Upload>
        <div class="_linkdel" v-for="file in form.applicantTaxPaymentCertificateGuidListPreview" :key="file.guid">
          <div class="fileCentent" @click="handlePreview(file)">
            <Icon :type="file.name | fileType" />
            {{file.name?file.name:file.fileName}}
          </div>
          <div class="fileDel">
            <Icon type="md-close" @click="handleRemove(file, null, 'applicantTaxPaymentCertificateGuidList',true)" />
          </div>
        </div>
      </FormItem>
      </Col>
      <Col span="24">
      <FormItem label="该员工是否劳务派遣" v-if="this.$store.state.enterpriseHasLaborDispatchPermit" prop="hasLaborDispatchPermit">
        <RadioGroup v-model.trim="form.hasLaborDispatchPermit">
          <Radio :label="true">是</Radio>
          <Radio :label="false">否</Radio>
        </RadioGroup>
      </FormItem>
      </Col>
      <Col span="12" v-if="form.hasLaborDispatchPermit===true">
      <FormItem label="派遣协议" prop="dispatchAgreementGuidList">
        <Upload :show-upload-list="false" :accept="$store.state.globalAccept" :format="$store.state.globalFormat" :default-file-list="form.dispatchAgreementGuidListPreview" :on-preview="handlePreview"
          :action="$baseURL + '/common/file/uploadfile'" :on-remove="
              (file, fileList) =>
                handleRemove(file, fileList, 'dispatchAgreementGuidList',true)
            " :on-success="
              (response, file, fileList) =>
                handleSuccess(response, file, fileList, 'dispatchAgreementGuidList',true)
            " :on-format-error="handleFormatError">
          <Button icon="ios-folder">上传电脑文件</Button>&nbsp;
          <Button icon="ios-camera" @click.stop="openQrCodeUpload('dispatchAgreementGuidList',true)">手机拍照上传</Button>
        </Upload>
        <div class="_linkdel" v-for="file in form.dispatchAgreementGuidListPreview" :key="file.guid">
          <div class="fileCentent" @click="handlePreview(file)">
            <Icon :type="file.name | fileType" />
            {{file.name?file.name:file.fileName}}
          </div>
          <div class="fileDel">
            <Icon type="md-close" @click="handleRemove(file, null, 'dispatchAgreementGuidList',true)" />
          </div>
        </div>
      </FormItem>
      </Col>
      <Col span="12" v-if="form.hasLaborDispatchPermit===true">
      <FormItem label="岗位协议" prop="jobAgreementGuidList">
        <Upload :show-upload-list="false" :accept="$store.state.globalAccept" :format="$store.state.globalFormat" :default-file-list="form.jobAgreementGuidListPreview" :on-preview="handlePreview"
          :action="$baseURL + '/common/file/uploadfile'" :on-remove="
              (file, fileList) =>
                handleRemove(file, fileList, 'jobAgreementGuidList',true)
            " :on-success="
              (response, file, fileList) =>
                handleSuccess(response, file, fileList, 'jobAgreementGuidList',true)
            " :on-format-error="handleFormatError">
          <Button icon="ios-folder">上传电脑文件</Button>&nbsp;
          <Button icon="ios-camera" @click.stop="openQrCodeUpload( 'jobAgreementGuidList',true)">手机拍照上传</Button>
        </Upload>
        <div class="_linkdel" v-for="file in form.jobAgreementGuidListPreview" :key="file.guid">
          <div class="fileCentent" @click="handlePreview(file)">
            <Icon :type="file.name | fileType" />
            {{file.name?file.name:file.fileName}}
          </div>
          <div class="fileDel">
            <Icon type="md-close" @click="handleRemove(file, null, 'jobAgreementGuidList',true)" />
          </div>
        </div>
      </FormItem>
      </Col>
      <Col span="24">
      <!-- class="noticeTop" -->
      <FormItem class="noticeTop" label="劳动合同" prop="laborContractGuidList">
        <Upload :show-upload-list="false" :accept="$store.state.globalAccept" :format="$store.state.globalFormat" :default-file-list="form.laborContractGuidListPreview" :on-preview="handlePreview"
          :action="$baseURL + '/common/file/uploadfile'" :on-remove="
              (file, fileList) =>
                handleRemove(file, fileList, 'laborContractGuidList',true)
            " :on-success="
              (response, file, fileList) =>
                handleSuccess(response, file, fileList, 'laborContractGuidList',true)
            " :on-format-error="handleFormatError">
          <Button icon="ios-folder">上传电脑文件</Button>&nbsp;
          <Button icon="ios-camera" @click.stop="openQrCodeUpload('laborContractGuidList',true)">手机拍照上传</Button>
        </Upload>
      </FormItem>
      <FormItem class="notice">
        <div>
          注：上传合同包含申请人个人信息（姓名、身份证号）、岗位信息、工作地、工作单位名称、劳动合同期限以及签字盖章的页面即可
        </div>
        <div class="_linkdel" v-for="file in form.laborContractGuidListPreview" :key="file.guid">
          <div class="fileCentent" @click="handlePreview(file)">
            <Icon :type="file.name | fileType" />
            {{file.name?file.name:file.fileName}}
          </div>
          <div class="fileDel">
            <Icon type="md-close" @click="handleRemove(file, null, 'laborContractGuidList',true)" />
          </div>
        </div>
      </FormItem>
      </Col>

      <!-- <Divider orientation="left">申请人婚姻状况</Divider>
      <Col span="24">
      <FormItem :label="'婚姻状况'" prop="applicantMaritalStatus" :rules="{
                  required: true,
                  message: '请选择',
                  trigger: 'change',
                  type:'number',
                }">
        <RadioGroup v-model.trim="form.applicantMaritalStatus">
          <Radio :label="value" @on-change="isSpouseRegisteredResidenceInSHChange" v-for="{ text, value } in $store.state.materiaBasicData
                    .maritalStatus" :key="value">{{ text }}</Radio>
        </RadioGroup>
      </FormItem>
      </Col>

      <template v-if="form.applicantMaritalStatus==$store.state.maritalStatusSet['初婚']||form.applicantMaritalStatus==$store.state.maritalStatusSet['再婚']">
        <Col span="24">
        <FormItem label="配偶是否是上海户籍" prop="isSpouseRegisteredResidenceInSH">
          <RadioGroup @on-change="isSpouseRegisteredResidenceInSHChange" v-model.trim="form.isSpouseRegisteredResidenceInSH">
            <Radio :label="true">是</Radio>
            <Radio :label="false">否</Radio>
          </RadioGroup>
        </FormItem>
        </Col>
      </template>
      <Divider orientation="left">持证人同住配偶和子女是否需要享受积分相关待遇</Divider>
      <template>
        <Col span="24">
        <FormItem label="请选择">
          <Checkbox v-show="form.isSpouseRegisteredResidenceInSH===false&&(form.applicantMaritalStatus==$store.state.maritalStatusSet['初婚']||form.applicantMaritalStatus==$store.state.maritalStatusSet['再婚'])" disabled
            v-model.trim="form.isSpouseEnjoyTreatment" label="配偶">配偶</Checkbox>
          <Checkbox disabled v-model.trim="form.isChildrenEnjoyTreatment" label="子女">子女</Checkbox>
        </FormItem>
        </Col>
      </template>
      <Divider orientation="left">申请人最高学历是否为高中以上学历（不包括高中学历）</Divider>
      <Col span="24">
      <FormItem prop="hasEducation" label="请选择">
        <RadioGroup v-model.trim="form.hasEducation">
          <Radio disabled :label="true">是</Radio>
          <Radio disabled :label="false">否</Radio>
        </RadioGroup>
      </FormItem>
      </Col> -->
      <!-- <Divider orientation="left">受理中心</Divider>
      <Col span="12">
      <FormItem label="请选择" prop="acceptanceCenter">
        <Select v-model.trim="form.acceptanceCenter" placeholder="请选择" style="width:100%">
          <Option v-for="{text,value} in $store.state.materiaBasicData.acceptanceCenterOption" :value="text" :key="value">{{ text }}</Option>
        </Select>
      </FormItem>
      </Col> -->
    </Row>
    <div class="bom_btn">
      <div>
        <Button @click="next(null,  -1)">上一步</Button>
        <Button type="primary" @click="next('form' + current, 1)">下一步</Button>
      </div>
    </div>
  </Form>
</template>
<script>
export default {
  props: {
    form: { type: Object },
    current: { type: Number },
    hasLaborDispatchPermit: { type: Boolean },
  },
  data() {
    return {
      format: ['jpg', 'png', 'jpeg'],
      accept: 'image/*',
      //   form: { id: 'ywlsh_12356789', kh: '新开户', sfzzm: [] },
      uploadData: { readIdInfo: true },
      //   ywlbList: [
      //     {
      //       name: '积分新办：年龄+教育背景（高于或等于本科学士）+社保年限',
      //       value: '积分新办：年龄+教育背景（高于或等于本科学士）+社保年限',
      //     },
      //   ],
      appInfoDataType: this.$store.state.appInfoDataType,
      current_index: this.current,

      rules: {
        personnelPhone: [{ required: true, message: '请输入', trigger: 'change' }],
        applicantIDCardFrontGuid: [{ required: true, message: '请上传', trigger: 'change' }],
        applicantIDCardBackGuid: [{ required: true, message: '请上传', trigger: 'change' }],
        applicantName: [{ required: true, message: '请输入', trigger: 'change' }],
        applicantIDCardNo: [
          { required: true, message: '请输入', trigger: 'change' },
          {
            pattern:
              /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
            message: '请输入正确的身份证号',
            trigger: 'blur',
          },
        ],
        applicantRegisteredResidenceType: [
          { required: true, message: '请选择', type: 'number', trigger: 'change' },
        ],
        applicantCollectiveAccountMaterialsType: [
          { required: true, message: '请选择', type: 'number', trigger: 'change' },
        ],
        applicantPoliceStationRegistrationCertificateGuid: [
          { required: true, message: '请上传', trigger: 'change' },
        ],
        applicantPhone: [
          { required: true, message: '请输入', trigger: 'change' },
          {
            pattern: /^[0-9]+$/,
            message: '请输入正确的联系方式',
            trigger: 'change',
          },
        ],
        applicantResidencePermitFrontGuid: [
          { required: true, message: '请上传', trigger: 'change' },
        ],
        dispatchAgreementGuidList: [
          { required: true, message: '请上传', trigger: 'change', type: 'array' },
        ],
        applicantTaxPaymentCertificateGuidList: [
          { required: true, message: '请上传', trigger: 'change', type: 'array' },
        ],
        laborContractGuidList: [
          { required: true, message: '请上传', trigger: 'change', type: 'array' },
        ],
        hasLaborDispatchPermit: [
          { required: true, message: '请选择', type: 'boolean', trigger: 'change' },
        ],
        acceptanceCenter: [{ required: true, message: '请选择', trigger: 'change' }],
        hasEducation: [{ required: true, message: '请选择', type: 'boolean', trigger: 'change' }],
        jobAgreementGuidList: [
          { required: true, message: '请上传', trigger: 'change', type: 'array' },
        ],
        applicantResidencePermitBackGuid: [
          { required: true, message: '请上传', trigger: 'change' },
        ],
        applicantResidencePermitExpiryDate: [
          {
            required: true,
            message: '请选择',
            type: 'date',
            trigger: 'change',
          },
        ],
        hasPersonFiles: [
          {
            required: true,
            message: '请选择',
            type: 'boolean',
            trigger: 'change',
          },
        ],
        isSpouseRegisteredResidenceInSH: [
          {
            required: true,
            message: '请选择',
            type: 'boolean',
            trigger: 'change',
          },
        ],
        declarationItems: [{ required: true, message: '请输入', trigger: 'change' }],
      },
      clList: ['rl', 'dw', 'yy', 'sh', 'rl'],
      selectList: [
        { name: '是', value: 1 },
        { name: '否', value: 0 },
      ],
    }
  },
  methods: {
    //下一步
    next(name, val) {
      //   this.$Message.success('Success!')
      let _this = this
      let submiteUrl = `/api/services/app/JZZJFApi/SaveAppApplicantInfo`

      if (name === null) {
        this.$emit('next', val, submiteUrl)
        return
      }

      this.$refs[name].validate(async (valid) => {
        if (!valid) {
          this.$Message.error('请将信息填写完整')
          return
        }

        _this.$emit('next', val, submiteUrl)
      })
    },
    openQrCodeUpload(property, isArray, isReadInfo, readIdInfoAfterToView) {
      this.$emit('openQrCodeUpload', property, isArray, isReadInfo, readIdInfoAfterToView)
    },
    //移除文件
    async handleRemove(file, fileList, property, isArray) {
      this.$emit('handleRemove', file, fileList, property, isArray)
    },
    //文件上传成功
    handleSuccess(response, file, fileList, property, isArray, isReadInfo, readIdInfoAfterToView) {
      this.$emit(
        'handleSuccess',
        response,
        file,
        fileList,
        property,
        isArray,
        isReadInfo,
        readIdInfoAfterToView
      )
    },
    //文件格式错误
    handleFormatError(file) {
      this.$emit('handleFormatError', file)
    },
    //上传前 用于单个上传清空上传列表
    handleBefore(property) {
      //不为数组时传一个删一个列表
      this.$refs[property].clearFiles()
    },
    //文件大小超出
    handleMaxSize(file) {
      this.$emit('handleMaxSize', file)
    },
    //预览
    handleView(guid) {
      this.$emit('handleView', guid)
    },
    //文件预览
    handlePreview(file) {
      this.$emit('handlePreview', file)
    },
    //时间格式化
    changeDateFmt(dateFmt, date, property) {
      this.$emit('changeDateFmt', dateFmt, date, property)
    },
    //户籍改变
    isSpouseRegisteredResidenceInSHChange(e) {},
    ////档案改变
    isArchiveInCurrentEnterpriseChange(e) {
      console.log('🚀 ~ isArchiveInCurrentEnterpriseChange ~ e:', e)
      if (e) {
        this.form.applicantArchivesCustodyInstitution = this.form.enterpriseName
      } else {
        this.form.applicantArchivesCustodyInstitution = ''
      }
    },
    updateProgress(event, file, fileList, name) {
      // this.percent = fileInfo.percent * 0.01
      this.$refs[name + 'Upload'].style.display = 'none'
      this.$refs[name].updateShow(true)
      this.$refs[name].updateProgress(Math.round(event.percent)) //=fileInfo.percent * 0.01

      this.$refs[name + 'Upload'].show = event.percent == 100
      // if (event.percent == 100) {
      //   this.$refs[name].updateShow(false)
      //   this.$refs[name + 'Upload'].style.display = 'block'
      // }
    },
  },
}
</script>